var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNedbankMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-256 256 512 512",
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "2.5rem",
      height: "2.5rem",
      fill: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117 258.1l139 91.5v328.9L117 770-.3 692.9-117 770l-139-91.5V349.9l139-91.9L-.4 335.1l117.4-77zm117.1 102.2l-116.3-77.2L1.4 360.3l-116.3-77.2-119.2 77.2v305.9l119.2 77.1L1.4 666.2l116.3 77.1L234 666.2l.1-305.9z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-113.5 589.8l93.1 62.9-93.1 62.9V589.8zm232.7-122.9V312.5l90.1 60v277.2l-418.7-274.4 95.9-62.9 232.7 154.5z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118 743.2l116.1-77V360.3h.1l-116.1-77.1L1.9 360.3l-.2-.1-.2.1-116.1-77.1-119 77.1v305.9l119 77 116.1-77 .2.1.2-.1 116.1 77zm-231.5-27.7V589.8l93.1 62.9-93.1 62.8zm-95.9-340.1l95.9-62.9 232.7 154.4V312.5l90.1 60v277.2l-418.7-274.3z",
    fill: "#1B613F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNedbankMoney);
export default __webpack_public_path__ + "static/media/nedbank-money.7e9dc14dcf2c0a0b1459c251ca919355.svg";
export { ForwardRef as ReactComponent };